import { AuthIFramePage } from "features/auth/AuthIFramePage";
import { AuthLayout } from "features/auth/AuthLayout";
import { AuthPage } from "features/auth/AuthPage";
import { Navigate, RouteObject } from "react-router-dom";
import NotFoundPage from "shared/components/empty/NotFoundPage";
import { AppConfig } from "shared/config/AppConfig";
import { isDev } from "shared/utils/DevUtils";

export const authRoutes: RouteObject = {
  id: "auth",
  path: "auth",
  element: <AuthPage />,
  children: [
    {
      id: "authIndex",
      index: true,
      element: <Navigate to="/" replace={true} />,
    },
    {
      id: "authIframe",
      path: "iframe",
      element: <AuthIFramePage />,
    },
    {
      id: "authLayout",
      element: <AuthLayout />,
      children: [
        {
          id: "authContinue",
          path: "continue",
          index: true,
          lazy: async () => {
            const { AuthContinuePage } = await import(
              "features/auth/AuthContinuePage"
            );
            return { Component: AuthContinuePage };
          },
        },
        {
          id: "authPasswordSetup",
          path: "password/setup",
          lazy: async () => {
            const { AuthPasswordSetupPage } = await import(
              "features/auth/password/AuthPasswordSetupPage"
            );
            return { Component: AuthPasswordSetupPage };
          },
        },
        {
          id: "authPasswordReset",
          path: "password/reset",
          lazy: async () => {
            const { AuthPasswordResetPage } = await import(
              "features/auth/password/AuthPasswordResetPage"
            );
            return { Component: AuthPasswordResetPage };
          },
        },
        {
          id: "authPassword",
          path: "password",
          lazy: async () => {
            const { AuthPasswordPage } = await import(
              "features/auth/password/AuthPasswordPage"
            );
            return { Component: AuthPasswordPage };
          },
        },
        {
          id: "authMfaSetup",
          path: "mfa/setup",
          lazy: async () => {
            const { AuthFactorSetupPage } = await import(
              "features/auth/factor/AuthFactorSetupPage"
            );
            return { Component: AuthFactorSetupPage };
          },
        },
        {
          id: "authMfa",
          path: "mfa",
          lazy: async () => {
            const { AuthFactorPage } = await import(
              "features/auth/factor/AuthFactorPage"
            );
            return { Component: AuthFactorPage };
          },
        },
        ...(isDev || !AppConfig.stytch
          ? [
              {
                id: "authLoginSimple",
                path: "login/simple",
                lazy: async () => {
                  const { LoginSimplePage } = await import(
                    "features/auth/LoginSimplePage"
                  );
                  return { Component: LoginSimplePage };
                },
              },
            ]
          : []),
        {
          id: "authLogin",
          path: "login",
          lazy: async () => {
            const { LoginPage } = await import("features/auth/LoginPage");
            return { Component: LoginPage };
          },
        },
        {
          id: "authLogout",
          path: "logout",
          lazy: async () => {
            const { LogoutPage } = await import("features/auth/LogoutPage");
            return { Component: LogoutPage };
          },
        },
      ],
    },
    {
      id: "authNotFound",
      path: "*",
      element: <NotFoundPage />,
    },
  ],
};
